import { deepMerge } from '@packages/shared';

/**
 * 注意：`useConfig` 仅是配置读取函数，不是 React Hooks。
 * 它不依赖组件生命周期，可在普通 TS/JS 模块中直接调用。
 */
export function useConfig() {
  const globalConfig = {
    // 这里可以预加载一些默认配置
    demoMode: true,
    demoStreamInterval: 0,
    // 页面层普通日志最小消费间隔（仅 demoMode 生效）
    demoPageConsumeInterval: 380,
    // 页面层步骤切换停留时长（仅 demoMode 生效）
    demoPageStepHoldMs: 1500,
    // 是否展示运行页“暂停 / 继续”能力及当前运行状态
    enableScenarioTaskPauseControl: false,
    // 运行场景任务页默认启用过程图形化展示
    enableProcessDiagram: true,
    scenarioTaskProcessDiagramRenderMode: '2d',
    scenarioTaskOrganizationDiagramRenderMode: '2d',
    // 组织图是否启用本地模拟头像注入（后端未返回头像字段时使用）
    enablePersonAvatarDemo: true,
    // 当前环境ENV_VALUE 等同于 dev
    env: 'ENV_VALUE', // dev test
    cashflowForecastScenarioOntologyIds: {
      dev: 190,
      test: 211,
    },
    eacProcessOntologyConfigs: {
      dev: {
        firstRound: {
          场景本体ID: '179',
          对象本体ID: 175,
        },
        secondRound: {
          场景本体ID: '180',
          对象本体ID: 175,
        },
      },
      test: {
        firstRound: {
          场景本体ID: '216',
          对象本体ID: 175,
        },
        secondRound: {
          场景本体ID: '217',
          对象本体ID: 175,
        },
      },
    },
    scenarioTaskMockPresetConfigs: {
      dev: {
        story: {
          scenarioOntologyId: 178,
          scenarioOntologyName: '编写场景故事元图版',
          objectOntologyId: 45,
          objectOntologyName: '座椅总成对象',
          knowledgeBaseName: 'BOM结构-请不要修改',
        },
        meddicc: {
          scenarioOntologyId: null,
          scenarioOntologyName: 'MEDDICC商机评分元图版',
          objectOntologyId: null,
          objectOntologyName: 'MEDDICC评分标准元图版',
        },
        experimentReport: {
          scenarioOntologyId: 184,
        },
      },
      test: {
        story: {
          scenarioOntologyId: 212,
          scenarioOntologyName: '',
          objectOntologyId: 45,
          objectOntologyName: '座椅总成对象',
          knowledgeBaseName: 'BOM结构-请不要修改',
        },
        meddicc: {
          scenarioOntologyId: 213,
          scenarioOntologyName: '',
          objectOntologyId: 215,
          objectOntologyName: '',
        },
        experimentReport: {
          scenarioOntologyId: 214,
        },
      },
    },
  };

  // _server_niepan_config
  const serverConfig = {
    // 这里可以预加载一些默认配置
    holonBaseUrl: 'https://holon.aialign.cn',
    gatewayBaseUrl: 'https://gateway-dev.aialign.cn', // 'http://10.8.0.125:9000', //
    parentOrigin: 'https://intelliu-dev.aialign.cn',
  };

  const _global = window as any;

  // 动态从 window 获取
  if (!_global._template_app_global_config) {
    console.warn(
      '请注意，当前未正确挂载 _template_app_global_config，请检查部署环境是否正确部署了 config.js'
    );
    _global._template_app_global_config = {};
  }

  if (!_global._template_app_server_config) {
    console.warn(
      '请注意，当前未正确挂载 _template_app_server_config，请检查部署环境是否正确部署了 config.js'
    );
    _global._template_app_server_config = {};
  }

  // 使用深度合并替代浅合并，确保嵌套对象和数组正确合并
  const mergedGlobalConfig = deepMerge(
    globalConfig,
    _global._template_app_global_config
  );
  const mergedServerConfig = deepMerge(
    serverConfig,
    _global._template_app_server_config
  );

  return {
    globalConfig: mergedGlobalConfig,
    serverConfig: mergedServerConfig,
  };
}
